
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Twentytempotravelleronrent() {



    const cardData =
    {
        keyword: '26 Seater Tempo Traveller On Rent in Pune',
        heading: 'Samarth Travels: 26 Seater Tempo Traveller On Rent in Pune',
        headingDescription: 'Samarth Travels offers 26 Seater Tempo Traveller on rent in Pune, ideal for large group travel, school or college trips, corporate events, and long-distance tours. Our spacious and well-maintained 26-seater Tempo Travellers feature air-conditioning, push-back seats, and ample legroom to provide a comfortable and convenient journey. With skilled drivers, flexible rental plans, and transparent pricing, Samarth Travels delivers safe, reliable, and affordable Tempo Traveller rental services across Pune.',

        top: 'Top Places to Visit in Pune Outstation with Samarth Travels',

      "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Nestled in the Western Ghats, Mahabaleshwar is a scenic hill station around 120 km from Pune. Known for its lush strawberry farms, panoramic viewpoints like Arthur’s Seat and Wilson Point, and the historic Mahabaleshwar Temple, it offers a cool and refreshing retreat. Boating on Venna Lake and walking through misty trails make it a perfect weekend getaway."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just about 65 km from Pune, the twin hill stations of Lonavala and Khandala are famous for their lush valleys, waterfalls, and forts like Rajmachi and Lohagad. The monsoon season enhances their charm, drawing travelers for trekking, picnics, and chikki shopping. Bhushi Dam and Tiger’s Leap are must-visit attractions in this green paradise."
    },
    {
      "title": "Shirdi",
      "description": "Located approximately 200 km from Pune, Shirdi is a revered pilgrimage town dedicated to Sai Baba. The Sai Baba Temple complex attracts millions of devotees each year. Besides the temple, other spots like Dwarkamai, Chavadi, and the Sai Heritage Village offer spiritual solace and insights into the saint’s life and teachings."
    },
    {
      "title": "Lavasa",
      "description": "Lavasa is a planned hill city about 60 km from Pune, offering Italian-style architecture and lakeside promenades. Popular for romantic getaways and weekend breaks, Lavasa features adventure sports, nature trails, and serene boat rides on the Warasgaon Lake. Its colorful buildings and vibrant cafes make it a photogenic escape."
    },
    {
      "title": "Alibaug",
      "description": "Alibaug is a coastal town around 140 km from Pune, known for its clean beaches and colonial forts. With attractions like Alibaug Beach, Kolaba Fort, and Mandwa Beach, it's a great destination for beach lovers. It’s ideal for water sports, seafood cuisine, and short family trips by road or ferry from Mumbai."
    },
    {
      "title": "Nashik",
      "description": "About 210 km from Pune, Nashik is a blend of spirituality and wine tourism. It’s home to the sacred Godavari River, Trimbakeshwar Temple, and Muktidham, making it a major religious center. Simultaneously, vineyards like Sula and York offer wine tasting and stunning vineyard views, making it a unique dual-experience destination."
    },
    {
      "title": "Kolhapur",
      "description": "Located 230 km from Pune, Kolhapur is rich in heritage, known for the Mahalaxmi Temple, New Palace Museum, and rankala Lake. It’s also famed for its spicy cuisine and handcrafted Kolhapuri chappals. A perfect cultural and culinary escape, Kolhapur provides a deep dive into Maharashtrian traditions."
    },
    {
      "title": "Bhimashankar",
      "description": "Approximately 110 km from Pune, Bhimashankar is a sacred Jyotirlinga shrine nestled in dense forests of the Sahyadri hills. Ideal for spiritual seekers and nature lovers, the region also forms part of a wildlife sanctuary. Trekking trails, misty landscapes, and temple architecture make it a soul-soothing destination."
    },
    {
      "title": "Matheran",
      "description": "Located about 120 km from Pune, Matheran is Asia’s only automobile-free hill station. Famous for its red-soiled paths, vintage toy train, and viewpoints like Panorama Point and Echo Point, it’s a tranquil retreat amidst nature. Horse rides and eco-friendly travel make it a unique experience."
    },
    {
      "title": "Goa",
      "description": "Though around 450 km away, Goa is a top outstation pick from Pune for those seeking beaches, nightlife, and Portuguese charm. From serene South Goa beaches like Palolem to lively North Goa spots like Baga and Anjuna, it’s perfect for parties, watersports, and cultural explorations. The drive or train journey adds to the adventure."
    }
  ],

    "services": [
    {
      "name": "26 Seater Tempo Traveller on Rent in Pune",
      "description": "Rent a 26-seater Tempo Traveller in Pune for various events like group outings, family trips, corporate trips, and more."
    },
    {
      "name": "Rent 26 Seater Tempo Traveller in Pune",
      "description": "We offer rental services for a 26-seater Tempo Traveller in Pune for comfortable and spacious travel for family, friends, or corporate teams."
    },
    {
      "name": "26 Seater Bus Rental Services Pune",
      "description": "Get reliable 26-seater bus rental services in Pune for events, tours, picnics, and corporate travel. Spacious and affordable."
    },
    {
      "name": "Tempo Traveller 26 Seater for Corporate Trips Pune",
      "description": "Rent a 26-seater Tempo Traveller for corporate trips in Pune, providing your team with a comfortable and luxurious travel experience."
    },
    {
      "name": "Rent 26 Seater Tempo Traveller for Group Outings",
      "description": "Ideal for group outings, rent a 26-seater Tempo Traveller in Pune for a hassle-free and comfortable journey with friends or colleagues."
    },
    {
      "name": "26 Seater Tempo Traveller for Sightseeing in Pune",
      "description": "Explore Pune with a 26-seater Tempo Traveller for sightseeing tours. Spacious and perfect for groups looking to visit top attractions."
    },
    {
      "name": "26 Seater Tempo Traveller Hire for Weddings",
      "description": "Hire a 26-seater Tempo Traveller in Pune for weddings. Comfortable and spacious transportation for guests to and from the event."
    },
    {
      "name": "26 Seater Tempo Traveller Rental Pune for Picnics",
      "description": "Rent a 26-seater Tempo Traveller for picnics in Pune. Perfect for a group travel experience to nearby destinations."
    },
    {
      "name": "Tempo Traveller 26 Seater for Outstation Trips",
      "description": "Rent a 26-seater Tempo Traveller for outstation trips from Pune, ideal for group travel to destinations across Maharashtra and beyond."
    },
    {
      "name": "26 Seater Tempo Traveller Rental Price Pune",
      "description": "Get affordable and competitive pricing for renting a 26-seater Tempo Traveller in Pune for various occasions and trips."
    },
    {
      "name": "Best Rental Services for 26 Seater Tempo Traveller in Pune",
      "description": "Looking for the best rental services for 26-seater Tempo Traveller in Pune? We offer reliable, comfortable, and budget-friendly options."
    }
  ],
  "tableData": [
    ["26 Seater Tempo Traveller on Rent in Pune", "Rent 26 Seater Tempo Traveller in Pune"],
    ["26 Seater Bus Rental Services Pune", "Tempo Traveller 26 Seater for Corporate Trips Pune"],
    ["Rent 26 Seater Tempo Traveller for Group Outings", "26 Seater Tempo Traveller for Sightseeing in Pune"],
    ["26 Seater Tempo Traveller Hire for Weddings", "26 Seater Tempo Traveller Rental Pune for Picnics"],
    ["Tempo Traveller 26 Seater for Outstation Trips", "26 Seater Tempo Traveller Rental Price Pune"],
    ["Best Rental Services for 26 Seater Tempo Traveller in Pune", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Spacious 26-Seater Tempo Traveller on Rent in Pune",
        "WhyChoosedescription": "Our 26-seater Tempo Traveller is the perfect solution for larger groups traveling together in and around Pune. Whether it's a family trip, corporate outing, or group tour, this vehicle provides the space and comfort needed for a relaxing journey."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious for Large Groups",
        "WhyChoosedescription": "The 26-seater Tempo Traveller is designed to ensure comfort during your travel. With spacious seating, ample legroom, air-conditioning, and enough space for luggage, it offers a premium travel experience for large groups."
    },
    {
        "WhyChooseheading": "Ideal for Family, Corporate, or Group Outings",
        "WhyChoosedescription": "Whether you're going on a family vacation, attending a corporate event, or planning a group sightseeing tour, our 26-seater Tempo Traveller is the ideal choice. It offers enough space for everyone to travel comfortably while ensuring that you stay together as a group."
    },
    {
        "WhyChooseheading": "Professional Drivers for Safe and Timely Travel",
        "WhyChoosedescription": "Our experienced and professional drivers are committed to providing a safe, smooth, and punctual journey. They are familiar with all major routes in Pune and surrounding areas, ensuring that your group reaches the destination on time without any hassle."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Group Travel",
        "WhyChoosedescription": "We offer affordable and transparent pricing for the 26-seater Tempo Traveller. Our rental packages are flexible to suit your travel needs and budget, with no hidden charges, making it a cost-effective option for large groups."
    },
    {
        "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
        "WhyChoosedescription": "Our 26-seater Tempo Traveller is available round the clock, allowing you to schedule travel at any time that suits your group. Whether you need early morning departures or late-night returns, we ensure that your travel needs are met."
    },
    {
        "WhyChooseheading": "Easy Booking with Real-Time Updates",
        "WhyChoosedescription": "Booking your 26-seater Tempo Traveller is quick and easy through our website or customer service. After booking, you will receive real-time updates on the vehicle's location, driver contact details, and arrival time, ensuring smooth coordination and peace of mind."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "We maintain our 26-seater Tempo Travellers to the highest standards of cleanliness and hygiene. Every vehicle is thoroughly sanitized before and after each trip to ensure a safe and healthy travel experience for all passengers."
    },
    {
        "WhyChooseheading": "Flexible Payment Options for Easy Transactions",
        "WhyChoosedescription": "We offer multiple secure payment options including UPI, credit/debit cards, digital wallets, and cash, allowing you to choose the most convenient method for completing your booking."
    }
]
































    }

const faqData = [
    {
        id: 1,
        question: 'How can I rent a 26-seater Tempo Traveller in Pune with Samarth Travels?',
        answer: 'Renting a 26-seater Tempo Traveller with Samarth Travels is simple. You can book the vehicle through our website or by calling our customer support team. Share your travel details such as the number of passengers, pick-up and drop-off locations, and travel dates, and we will arrange the ideal Tempo Traveller for your needs.',
    },
    {
        id: 2,
        question: 'What features are available in the 26-seater Tempo Traveller?',
        answer: 'Our 26-seater Tempo Traveller is designed to provide maximum comfort for group travel. It includes features such as air conditioning, spacious seating, ample luggage space, reclining seats, USB charging ports, and clean interiors to ensure a pleasant journey for all passengers.',
    },
    {
        id: 3,
        question: 'What are the rental charges for a 26-seater Tempo Traveller in Pune?',
        answer: 'The rental charges for a 26-seater Tempo Traveller in Pune start at ₹35/km for local trips. Outstation trips are charged on a per-day basis with minimum km usage. For more accurate pricing, feel free to contact us with your travel details and we will provide a customized quote.',
    },
    {
        id: 4,
        question: 'Can I customize the pick-up and drop-off locations for the 26-seater Tempo Traveller?',
        answer: 'Yes, we offer flexible pick-up and drop-off options based on your travel requirements. Whether it’s from your hotel, home, or specific venue, we will accommodate your preferences to ensure a convenient and smooth experience.',
    },
    {
        id: 5,
        question: 'Does the rental include a driver and fuel?',
        answer: 'Yes, all rentals for the 26-seater Tempo Traveller include a professional driver and fuel charges. Any additional costs like tolls, parking, or permits will be communicated upfront to ensure complete transparency.',
    },
    {
        id: 6,
        question: 'Is the 26-seater Tempo Traveller suitable for long-distance travel?',
        answer: 'Yes, the 26-seater Tempo Traveller is ideal for long-distance journeys. With comfortable seating, air conditioning, and plenty of luggage space, it ensures that your group will travel comfortably, whether it’s a short trip or a longer tour.',
    },
    {
        id: 7,
        question: 'Is 24/7 customer support available for 26-seater Tempo Traveller rentals?',
        answer: 'Yes, Samarth Travels provides 24/7 customer support for all our rentals, including the 26-seater Tempo Traveller. Whether you need assistance with bookings, last-minute changes, or support during your trip, our team is always available to help.',
    },
];

const testimonials = [
    {
        name: 'Mr. Amit Agarwal',
        role: 'Corporate Travel Manager',
        text: 'We rented a 26-seater Tempo Traveller for a corporate team-building trip. The vehicle was spacious, comfortable, and well-maintained. The driver was courteous and professional, and the entire booking process was hassle-free. Samarth Travels made our team outing memorable.',
        image: '/img/testimonial/testi_temptraveller_amit.jpg',
    },
    {
        name: 'Ms. Priya Deshmukh',
        role: 'Event Organizer',
        text: 'Booked a 26-seater Tempo Traveller for a destination wedding event. The vehicle was clean, comfortable, and perfect for transporting guests between venues. Samarth Travels made sure everything was on time and smooth. I highly recommend their services!',
        image: '/img/testimonial/testi_temptraveller_priya.jpg',
    },
    {
        name: 'Mr. Ravi Kumar',
        role: 'Tour Guide',
        text: 'We used a 26-seater Tempo Traveller for a group trip to Mahabaleshwar. The vehicle had ample space for our group and luggage, and the air conditioning kept everyone comfortable throughout the journey. Excellent service and a very smooth experience with Samarth Travels.',
        image: '/img/testimonial/testi_temptraveller_ravi.jpg',
    },
    {
        name: 'Ms. Sonal Mehta',
        role: 'Family Trip Planner',
        text: 'Rented a 26-seater Tempo Traveller for a family trip to Goa. The vehicle was comfortable, well-maintained, and spacious enough for our large family. The driver was polite and ensured our safety and comfort throughout the journey. A great experience with Samarth Travels!',
        image: '/img/testimonial/testi_temptraveller_sonal.jpg',
    },
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "26 Seater Tempo Traveller On Rent in Pune",
  "image": "https://samarthtravels.com/assets/images/26-seater-tempo-traveller-rent-pune.jpg", // Replace with the correct image URL
  "description": "Rent a 26 Seater Tempo Traveller in Pune for group outings, corporate trips, sightseeing, picnics, and weddings. Affordable rates and comfortable travel experience with Samarth Travels for all your travel needs.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5362"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5500",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/26-seater-tempo-traveller-on-rent-pune" // Replace with the actual page URL
  }
};







    return (
        <div>

<Helmet>
  <title>26 Seater Tempo Traveller On Rent in Pune | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a 26 Seater Tempo Traveller in Pune for group outings, corporate trips, sightseeing, picnics, and weddings. Affordable rates and comfortable travel experience with Samarth Travels for all your travel needs." 
  />
  <meta 
    name="keywords" 
    content="26 Seater Tempo Traveller on rent in Pune, Rent 26 Seater Tempo Traveller in Pune, 26 Seater bus rental services Pune, Tempo Traveller 26 seater for corporate trips Pune, Rent 26 Seater Tempo Traveller for group outings, 26 Seater Tempo Traveller for sightseeing in Pune, 26 Seater Tempo Traveller hire for weddings, 26 Seater Tempo Traveller rental Pune for picnics, Tempo Traveller 26 seater for outstation trips, 26 Seater Tempo Traveller rental price Pune, Best rental services for 26 Seater Tempo Traveller in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/88.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Twentytempotravelleronrent;